import { bindTokenProvider, createHttpClient, session } from '@/core';

/**
 * HTTP 装配点 — 直连／代理两档（《前端项目开发文档 v1.1》§3.5 + 《后端项目开发文档 v1.5》§6.0）
 *
 * | 档位 | 变量 | 行为 |
 * |---|---|---|
 * | 直连 | `VITE_API_BASE_URL=http://<backend-host>:<port>` | 真实请求；**不拼 /api** |
 * | 走代理 | `VITE_API_BASE_URL=` 空（同源） | 由 vite server.proxy 按路由根转发，**不使用 rewrite** |
 *
 * ⚠ seq=2216 之后的判法（`core/http/envelopeResult.ts`）：判成败**只看 `resultCode`**。09-18 那趟只新增
 * 这枚键，此前部署版没有它 ⇒ 直连真服务时每一条应答都会判**不通过**（页面读成「加载失败」＋一条漂移证据）。
 * 那是换判法的已知代价、不是后端的缺陷：不当它报障，也不回读隔壁那枚 `code` 兜底。
 *
 * 本文件原有的第③档「契约 mock」（`VITE_USE_MOCK` 旁路网络）与 §6.2 缺口接桩（唯一桩源就是 mock
 * 运行档）已随本批删除：前端只走真实后端，见 coord/mock-removal/delivery-admin/README.md。
 */

/** 401：清会话 + 跳登录（带 redirect 回跳），由路由守卫兜底 */
bindTokenProvider({
  getAccessToken: () => session.getAccessToken(),
  onUnauthorized: () => {
    session.clearSession();
    const redirect = encodeURIComponent(window.location.hash.replace(/^#/, '') || '/orders');
    window.location.hash = `#/login?redirect=${redirect}&reason=session`;
  },
});

export const http = createHttpClient();

export { getContractDrift } from '@/core';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '(同源 → dev proxy)';
